import { WithStringValues } from "common/utils/types";

import { SubscriptionListSearch } from "../types";

export const urls = {
  subscriptions: () => "/api/client/v1/subscriptions/",
  subscription: (id: number) => `/api/client/v1/subscriptions/${id}/`,
  onboardingSubscription: (id: number) => `/api/client/v1/subscriptions/${id}/onboarding/`,
  subscriptionPayment: (id: number) => `/api/client/v1/subscriptions/${id}/payment/`,
  bulkUpdateSubscriptions: () => `/api/client/v1/subscriptions/bulk-update/`,
};

export const keys = {
  all: () => ["subscriptions-all"],
  // subscriptions
  subscriptions: () => [...keys.all(), "subscriptions"],
  subscriptionLists: () => [...keys.subscriptions(), "list"],
  subscriptionList: (search: WithStringValues<SubscriptionListSearch>) => [
    ...keys.subscriptionLists(),
    search,
  ],
  subscriptionDetails: () => [...keys.subscriptions(), "detail"],
  subscriptionDetail: (id: number) => [...keys.subscriptionDetails(), id],
  onboardingSubscriptionDetail: (id: number) => [...keys.subscriptionDetails(), "onboarding", id],
};
